import { gql } from "@apollo/client";
const GET_LABELS = gql `
  query GetDictionary($locale: SiteLocale, $filterPattern: [String]) {
    allSharedDictionaries(
      locale: $locale
      filter: { key: { in: $filterPattern } }
    ) {
      id
      key
      value
    }
  }
`;
export default GET_LABELS;
